const testimonialInitiatives = [
	{
		path: '/agency/testimonial-initiatives/list',
		name: 'agency-testimonial-initiatives-list',
		component: () => import('@/views/agency/testimonial-initiatives/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
]

export default testimonialInitiatives
